import { render, staticRenderFns } from "./DCDetail.vue?vue&type=template&id=70453dd0&scoped=true"
import script from "./DCDetail.vue?vue&type=script&lang=js"
export * from "./DCDetail.vue?vue&type=script&lang=js"
import style0 from "./DCDetail.vue?vue&type=style&index=0&id=70453dd0&lang=scss&scoped=true"
import style1 from "./DCDetail.vue?vue&type=style&index=1&id=70453dd0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70453dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70453dd0')) {
      api.createRecord('70453dd0', component.options)
    } else {
      api.reload('70453dd0', component.options)
    }
    module.hot.accept("./DCDetail.vue?vue&type=template&id=70453dd0&scoped=true", function () {
      api.rerender('70453dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/DC/DCDetail.vue"
export default component.exports